export const customerStatusEnum = {
  ACTIVE: 0,
  INACTIVE: 1,
}

export const customerStatus = {
  [customerStatusEnum.ACTIVE]: 'Active',
  [customerStatusEnum.INACTIVE]: 'Inactive',
}